/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetBrandThirdPartyContentEnabledRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetBrandThirdPartyContentEnabledResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setBrandThirdPartyContentEnabled = (request: SetBrandThirdPartyContentEnabledRequest, options?: CashRequestOptions) => post<SetBrandThirdPartyContentEnabledRequest, SetBrandThirdPartyContentEnabledResponse>("/2.0/cash/set-brand-third-party-content-enabled", request, {...options, rejectOnError: true })